var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "1453 1293.95 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1453 1312.9a19 19 0 1 1 0 .1z",
    fill: "#e8e7ff",
    fillRule: "evenodd",
    "data-name": "Icon.BG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6877-1838v-2h-2v-2h2v-2h2v2h1.999v2H-6875v2h-2Zm-12 0v-1c0-2.8 2.2-5 5-5h3v2h-3c-1.3 0-2.4.8-2.8 2h5.8v2h-8Zm3-11v-1c0-2.2 1.8-4 4-4s3.999 1.8 3.999 4v1c0 2.2-1.8 4-3.999 4a4.011 4.011 0 0 1-4-4Zm2-1v1c0 1.1.9 2 2 2s2-.9 2-2v-1c0-1.1-.9-2-2-2s-2 .9-2 2Z",
    fillRule: "evenodd",
    fill: "url(\"#a\")",
    transform: "translate(8353 3159)",
    "data-name": "New customer Icon"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8280ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e96ff",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCon);
export default __webpack_public_path__ + "static/media/person_con.f3d5fa527cd94c827ea2dfe274ca29e8.svg";
export { ForwardRef as ReactComponent };